/** Wrap tables for responsive scrolling */
export function initTableWrap(): void {
  document.querySelectorAll('.markdown-body table').forEach((table) => {
    if (table.closest('.table-area')) return
    const wrapper = document.createElement('div')
    wrapper.className = 'table-area'
    table.parentNode?.insertBefore(wrapper, table)
    wrapper.appendChild(table)
  })
}
